<script lang="ts">
	import {uqn} from './stores.js';
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	//import Slider from '@smui/slider';
	import Slider from './slider';
	import FormField from '@smui/form-field';
	import uqnSplit from './functions/uqnSplit';
	import uqnJoin from './functions/uqnJoin';
	import RadioGroup from './RadioGroup.svelte';
	//import SliderNonZero from './SliderNonZero.svelte';
	import {random, check} from './check_random/random';
	import getRandomInt from './functions/getRandomInt';
	import katexify from './functions/katexify';
	import Fraction from './functions/fractionClass';
	
	let simpleDialog;
	
	let _: any;
	let aSlide: number;
	let bSlide: number;
	let cSlide: number;
	let kSlide: number;
	let type: string;
	let subType: string;
	let subType6: string;
	let uqnInput: number;
	
	// initialize
	function initializer(u:number){
		const [t,a,b,c,k] = uqnSplit(u);
		uqnInput = u;
		aSlide = a;
		bSlide = b;
		cSlide = c;
		kSlide = k;
		subType6 = k.toString();
		type = t<5? "1" : t.toString();
		subType = t<5? t.toString() : "0";
	}
	initializer($uqn);

	// reactive
	$: _ = updateFromType(type);
	$: _ = updateFromSubType(subType);
	$: _ = updateFromSubType6(subType6);
	$: _ = initializer($uqn);
	$: _ = updateSlider1(aSlide,bSlide,cSlide,kSlide);

	let options = [
		{value: "1", label: "Type 1"},
		{value: "5", label: "Type 2"},
		{value: "6", label: "Type 3"}
	]
	let optionsB = [ // Type 1 sub type
		{value: "1", label: "P(A \\cap B)", katex: true},// 1: a cap b, 2: a | b, 3: a | b', 4: a' | b
		{value: "2", label: "P(A \\mid B)", katex: true},
		{value: "3", label: "P(A \\mid B')", katex: true},
		{value: "4", label: "P(A' \\mid B)", katex: true}
	]
	let optionsB6 = [ // Type 1 sub type
		{value: "1", label: "A' \\textrm{ and } B", katex: true},// 1: a cap b, 2: a | b, 3: a | b', 4: a' | b
		{value: "2", label: "A \\textrm{ and } B'", katex: true},
		{value: "3", label: "A' \\textrm{ and } B'", katex: true},
	]
	function updateFromType(t:string){
		const [type,a,b,c,k] = uqnSplit($uqn);
		if ((t=="5"||t=="6") && t!=type.toString()){
			uqnInput = random(Number(t));
			uqn.set(uqnInput);
		} else if (t=="1"){
			if (type > 4){
				uqnInput = random(getRandomInt(1,4));
				uqn.set(uqnInput);
			}
		}
	}
	function updateFromSubType(sT:string){
		const [type,a,b,c,k] = uqnSplit($uqn);
		if ((type<5) && (type.toString() != sT)){
			uqnInput = uqnJoin([Number(sT), a,b,c,k]);
			uqn.set(uqnInput);			
		}
	}
	function updateFromSubType6(sT:string){
		const [type,a,b,c,k] = uqnSplit($uqn);
		if ((type==6) && (k.toString() != sT)){
			uqnInput = uqnJoin([type, a,b,c,Number(sT)]);
			uqn.set(uqnInput);			
		}
	}
	function updateSlider1(a1:number,b1:number,c1:number,k1:number){
		const [type,a,b,c,k] = uqnSplit($uqn);
		if (type!=6){ 
			if (a != a1){
				uqnInput = uqnJoin([type, a1,b,c,k]);
				uqn.set(uqnInput);
			} else if (b != b1){
				uqnInput = uqnJoin([type, a,b1,c,k]);
				uqn.set(uqnInput);
			} else if (c != c1){
				uqnInput = uqnJoin([type, a,b,c1,k]);
				uqn.set(uqnInput);
			} else if (k != k1){
				uqnInput = uqnJoin([type, a,b,c,k1]);
				uqn.set(uqnInput);
			}
		} else{
			if (a != a1){
				uqnInput = uqnJoin([type, a1,b,c,k]);
				uqn.set(uqnInput);			
			} else if (b != b1){
				if (b1+c <= 9){
					uqnInput = uqnJoin([type, a,b1,c,k]);
					uqn.set(uqnInput);
				} else{
					bSlide = 9-c;
					uqnInput = uqnJoin([type, a,bSlide,c,k]);
					uqn.set(uqnInput);
				}
			} else if (c != c1){
				if (b+c1 <= 9){
					uqnInput = uqnJoin([type, a,b,c1,k]);
					uqn.set(uqnInput);
				} else{
					cSlide = 9-b;
					uqnInput = uqnJoin([type, a,b,cSlide,k]);
					uqn.set(uqnInput);
				}
			}
		}
	}
	function uqnClick(){
		if (check(uqnInput)){
			uqn.set(uqnInput)
		} else{
			simpleDialog.open();
		}
	}
</script>

<h2>Options</h2>
<hr>
<h3>UQN</h3>
<p>
	Retrieve a question by keying in a 5 digit UQN :
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={uqnInput} label="UQN" type="number"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<Label>Generate question</Label>
</Button>
<hr>
<h3>
	Question construction tools
</h3>
<p>There are three main types of question:</p>
<RadioGroup bind:radio={type} options={options}/>
<hr>
{#if type=="1"}
<p>We can choose the probability that will be given:</p>
<RadioGroup bind:radio={subType} options={optionsB}/>
<hr>
{:else if type=="6"}
<p>In part (a) we will prove the independence of:</p>
<RadioGroup bind:radio={subType6} options={optionsB6}/>
<hr>
{/if}
{#if type!="6"}
<p>
	Use the sliders below to choose {@html katexify('P(A), P(B)')} and {@html katexify('P(C)')}:
</p>
<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={aSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;">{@html katexify("P(A)=0."+aSlide.toString())}</span>
		</FormField>
</div>
<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={bSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;">{@html katexify("P(B)=0."+bSlide.toString())}</span>
		</FormField>
</div>
<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={cSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;">{@html katexify("P(C)=0."+cSlide.toString())}</span>
		</FormField>
</div>
<p>
	This last slider affects
	{#if type=="5"}
		{@html katexify('P(A \\cap B \\cap C)')}:
	{:else}
		{@html katexify('P(A \\cap B)')}:
	{/if}
</p>
<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={kSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;">{@html katexify("k="+kSlide.toString())}</span>
		</FormField>
</div>
{:else}
<p>
	Use the slider below to choose {@html katexify('P(A)')}:
</p>
<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={aSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;">{@html katexify("P(A)=0."+aSlide.toString())}</span>
		</FormField>
</div>
<p>
	The next slider affects {@html katexify('P(B \\cap C)')}:
</p>
<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={bSlide} min={1} max={9} step={1} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;">{@html katexify("k_1="+bSlide.toString())}</span>
		</FormField>
</div>
<p>
	The next slider affects {@html katexify("P(A' \\cap B' \\cap C')")}:
</p>
<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={cSlide} min={1} max={9} step={1} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;">{@html katexify("k_2="+cSlide.toString())}</span>
		</FormField>
</div>
{/if}

<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid UQN</Title>
	<Content>
		You have keyed an invalid UQN. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>